var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-subject-filter"},[_c('v-card',{staticClass:"pa-2 mt-2",attrs:{"flat":""}},[_c('v-card-title',[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"orange"}}):_vm._e(),_c('h3',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-spacer'),_c('div',[_c('GoBackBtn')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }